export const version = "2.2.1022";
export const domain = "https://add.nurulquran.com"
